module.exports = __webpack_public_path__ + "static/media/jidloPodNosLogo.a43315ac.svg";